import { Injectable, Injector } from '@angular/core';

@Injectable()
export class AppService {
    static injector: Injector;
    constructor(injector: Injector) {
        AppService.injector = injector;
    }
}
